export default function ArchiveIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M0.812012 9.25H3.39152C3.46538 9.25 3.53853 9.26455 3.60678 9.29282C3.67502 9.32109 3.73703 9.36252 3.78926 9.41475L5.14726 10.7727C5.19949 10.825 5.2615 10.8664 5.32975 10.8947C5.39799 10.923 5.47114 10.9375 5.54501 10.9375H8.45402C8.52789 10.9375 8.60103 10.923 8.66928 10.8947C8.73752 10.8664 8.79953 10.825 8.85177 10.7727L10.2098 9.41475C10.262 9.36252 10.324 9.32109 10.3922 9.29282C10.4605 9.26455 10.5336 9.25 10.6075 9.25H13.187M1.37492 0.8125H12.6249C12.9356 0.8125 13.1874 1.06434 13.1874 1.375V12.625C13.1874 12.9357 12.9356 13.1875 12.6249 13.1875H1.37492C1.06426 13.1875 0.812424 12.9357 0.812424 12.625V1.375C0.812424 1.06434 1.06426 0.8125 1.37492 0.8125Z"
        stroke="#AFBACA"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
